import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import RelatedStoriesBasic from 'components/Pages/ArticleParts/RelatedStoriesBasic';
import RelatedHelpArticlesSection from 'components/Sections/RelatedArticlesVariations/RelatedHelpArticlesSection';
import { GetStaticComponentProps, useComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { defaultLanguage } from 'temp/config';
import { helpArticlesService } from 'lib/services/HelpArticleService';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { TaggedHelpArticle } from 'model/HelpArticle';

const RelatedTaggedHelp = ({
  rendering,
  helpArticlePlaceholder,
  params,
}: ComponentProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { t } = useI18n();
  const articles = useComponentProps<TaggedHelpArticle[]>(rendering.uid);
  const { sitecoreContext } = useSitecoreContext();
  const baseUrl = sitecoreContext.helpArticleWildcardConfiguration?.baseUrl;
  const parentIsHelpArticlePlaceholder = helpArticlePlaceholder;

  if (!articles?.length) return null;

  if (parentIsHelpArticlePlaceholder) {
    return (
      <RelatedStoriesBasic
        articles={articles}
        id={anchorId}
        title={t('helpMoreFrom')}
        rendering={rendering}
        baseUrl={baseUrl}
      />
    );
  } else {
    return (
      <RelatedHelpArticlesSection
        params={params}
        articles={articles}
        id={anchorId}
        className="d-none d-md-block"
        rendering={rendering}
        baseUrl={baseUrl}
        title={t('relatedTaggedHelpTitle')}
      />
    );
  }
};

export const getStaticProps: GetStaticComponentProps = async (rendering, layoutData) => {
  const siteId = layoutData.sitecore.context?.siteRoot;
  const language = layoutData.sitecore.context.language ?? defaultLanguage;
  const articleData = layoutData.sitecore.context.helpArticle;
  if (!articleData) return [];

  if (articleData) {
    const helpTagId = articleData.helpTag.targetItem?.id;
    const { taggedHelpArticles } = layoutData.sitecore.context.helpArticleWildcardConfiguration;
    const taggedArticlesIDs =
      taggedHelpArticles.find((article) => article.tagId.value === helpTagId)?.articles?.value ??
      [];
    return await helpArticlesService.getTaggedHelpArticles(
      language,
      siteId,
      articleData.currentArticleID,
      taggedArticlesIDs
    );
  }
};

export default RelatedTaggedHelp;
